var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expert-advisory"},[_c('p',{staticClass:"text"},[_vm._v("使用手机钉钉扫描群二维码入群，进行税费优惠政策远程协助预约。")]),_c('img',{staticClass:"qrcode",attrs:{"src":require("@/assets/images/expert_advisory.jpg"),"alt":"","width":"300px"}})])
}]

export { render, staticRenderFns }